import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@serviceplan/ui-kit';
import { PROMPTS } from '@thehubz/client/core';
import { SelectCollectionPopupComponent } from '../components/select-collection-popup/select-collection-popup.component';

@Injectable()
export class SelectCollectionDialogService {
  /**
   * Show confirm dialog before closing the stepper dialog
   * @param dialog MatDialog service for opening a dialog
   * @param parentDialogRef Reference to parent dialog to be closed
   */
  confirmDialogClose(dialog: MatDialog, parentDialogRef: MatDialogRef<SelectCollectionPopupComponent, any>) {
    const _confirmDialogRef = dialog.open(ConfirmDialogComponent, {
      data: {
        title: $localize`Confirm`,
        message: $localize`Are you sure you want to close? All unsaved data will be lost`,
        confirmCaption: PROMPTS.LABELS.YES,
        cancelCaption: PROMPTS.LABELS.NO,
      },
    });
    _confirmDialogRef.disableClose = true;
    _confirmDialogRef.afterClosed().subscribe((data) => {
      if (data) parentDialogRef.close();
    });
  }
}
